import type { PageMeta } from '../types/seo'

export const pages: PageMeta[] = [
  {
    path: '/',
    title: 'Break a Pencil Consulting | AI Team Capability Programs',
    description:
      "Individuals on your team are using AI. Your team isn't. Michael Hirsch helps leaders get their whole team using AI effectively through multi-week programs built around real work.",
  },
  {
    path: '/my-story',
    title: 'My Story | Break a Pencil Consulting',
    description:
      '20+ years leading teams at Sony, Qualcomm, T-Mobile, and HERE Technologies, and an adjunct professor of business strategy. Now helping leaders build AI capability across their teams.',
  },
  {
    path: '/services',
    title: 'Services | Team AI Capability Program | Break a Pencil',
    description:
      'A multi-week program that shows where your team stands with AI, builds hands-on skills around real work, and keeps momentum going with internal AI champions. Workshops and speaking also available.',
  },
  {
    path: '/results',
    title: 'Results and Case Studies | Break a Pencil Consulting',
    description:
      'How teams at Snøhetta, HTEC Group, and Motorola Solutions went from uneven AI use to shared, lasting capability, including 5-10 hours of time saved each week.',
  },
  {
    path: '/resources',
    title: 'Resources | Break a Pencil Consulting',
    description:
      'Broken Pencils, a newsletter on AI transformation and leadership, plus videos and talks on building AI capability across your team.',
  },
  {
    path: '/contact',
    title: 'Contact | Book an Intro Call | Break a Pencil',
    description:
      'Book a 30-minute intro call with Michael Hirsch to talk about AI transformation for your team, or reach out by email or LinkedIn.',
  },
  {
    path: '/booked',
    title: "You're Booked | Break a Pencil Consulting",
    description:
      'Your intro call with Michael Hirsch is scheduled. A calendar invite is on its way.',
    noindex: true,
  },
]
